<template>
  <div class="yxtbiz-aibox" ref="aiboxRef">
    <div class="container" :class="{ 'fullscreen': isFullscreen }" v-loading="dataLoading">
      <transition name="panel-slide">
        <div class="panel" v-if="isFullscreen" v-show="isExpand">
          <div class="aibox-info">
            <div class="app-info">
              <yxtf-portrait size="72px" class="portrait" :imgUrl="appData.icon"></yxtf-portrait>
              <div class="app-name ellipsis">{{ appData.appName }}</div>
            </div>
          </div>
          <div class="option">
            <div class="option-left"></div>
            <div class="option-right">
              <div @click="isExpand = false">
                <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" icon-class="shrink1" class="color-gray-7 hover-primary-6 hand icon"/>
              </div>
            </div>
          </div>
        </div>
      </transition>
      <div class="expand-btn hand" v-show="isFullscreen && !isExpand"  @click="isExpand = true">
        <span class="text">展开</span>
        <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" icon-class="expand1"/>
      </div>
      <div class="main">
        <div class="header">
          <div class="left" :class="{ 'hidden': isFullscreen }">
            <yxtf-portrait size="36px" :imgUrl="appData.icon"></yxtf-portrait>
            <span class="app-name ellipsis">{{ appData.appName }}</span>
          </div>
          <div class="right">
            <span @click="toggleFullscreen">
              <yxtf-svg :width="iconSize" :height="iconSize" :remote-url="iconUrl" :icon-class="isFullscreen ? 'ai-window' : 'ai-screen'" class="color-gray-7 hover-primary-6 hand icon"/>
            </span>
            <span @click="onClose">
              <yxtf-svg :width="iconSize" :height="iconSize" :remote-url="iconUrl" icon-class="ai-closed" class="color-gray-7 hover-primary-6 hand icon"/>
            </span>
          </div>
        </div>
        <yxtf-scrollbar fitHeight class="chat-container">
          <chat-box ref="chatBoxRef" :showPortrait="isFullscreen" :loading="loading" :chat-list="qaList" :service-img="appData.icon">
            <template v-slot:top-option="slotProps">
              <div class="top-opt-btn icon-btn-status" :class="{'icon-btn-active': slotProps.data.appraisement === 1, 'icon-btn-disabled': slotProps.data.appraisement === 2}" @click="onFeedbackItem(slotProps, 1)">
                <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" :icon-class="slotProps.data.appraisement ? 'great' : 'great-outline'"/>
              </div>
              <div class="top-opt-btn icon-btn-status" :class="{'icon-btn-active': slotProps.data.appraisement === 2, 'icon-btn-disabled': slotProps.data.appraisement === 1}" @click="onFeedbackItem(slotProps, 2)">
                <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" :icon-class="slotProps.data.appraisement ? 'bad' : 'bad-outline'"/>
              </div>
            </template>
            <template v-slot:option="slotProps">
              <div class="option-left">
                <div v-if="slotProps.data.showStaffservice && slotProps.index === qaList.length - 1" :class="{'font-size-16': isFullscreen}">
                  <span class="tips">抱歉，目前无法解答您的问题，您可以</span>
                  <yxtf-link @click="onStaffservice" type="primary" :underline="false">转人工</yxtf-link>
                </div>
              </div>
              <div class="option-right" v-show="!slotProps.data.appraisement">
                <div class="option-btn-mini icon-btn-status" :class="{'icon-btn-active': slotProps.data.appraisement === 1, 'icon-btn-disabled': slotProps.data.appraisement === 2}" @click="onFeedbackItem(slotProps, 1)">
                  <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" :icon-class="slotProps.data.appraisement ? 'great' : 'great-outline'"/>
                </div>
                <div class="option-btn-mini icon-btn-status" :class="{'icon-btn-active': slotProps.data.appraisement === 2, 'icon-btn-disabled': slotProps.data.appraisement === 1}" @click="onFeedbackItem(slotProps, 2)">
                  <yxtf-svg width="20px" height="20px" :remote-url="ICON_PATH" :icon-class="slotProps.data.appraisement ? 'bad' : 'bad-outline'"/>
                </div>
              </div>
            </template>
            <template v-slot:customOption="slotProps">
              <feekback-box v-if="slotProps.index === activeFeedbackIndex" @submit="(tags, content) => onSubmitFeedback(slotProps.data, tags, content)" @cancel="activeFeedbackIndex = -1" :loading="feedbackLoading"></feekback-box>
            </template>
            <template v-slot:customItem="slotProps">
              <div v-if="slotProps.data.type === 'tips'" class="chat-tips">
                 <div>平台操作有疑问？我是您的智能AI助手，随时待命解答您的每一个操作问题！您可以尝试用下面的方法问我哦。</div>
                 <div class="tips-opt">
                  <div>你可以试着这样问我：</div>
                  <div class="tips-btn" @click="getExample">
                    <yxtf-svg :width="16" :height="16" :remote-url="ICON_PATH" icon-class="refresh" class="icon" style="margin-right: 8px;"/>
                    换一换
                  </div>
                 </div>
                 <div class="example-list" :class="{ 'full-screen': isFullscreen }" v-loading="exampleLoading">
                    <div class="example-item" v-for="(item, index) in exampleList" :key="index" @click="onSelectQuestion(item)">
                      <div class="example-text">{{ item }}</div>
                    </div>
                  </div>
              </div>
              <div v-if="slotProps.data.type === 'staffservice'">
                <div style="display:inline-block; vertical-align: middle;">好的，请点击唤起客服</div>
                <yxtf-link :class="{'font-size-16': isFullscreen}" style="margin-left: 12px;"  @click="onStaffservice" type="primary" :underline="false">转人工</yxtf-link>
              </div>
            </template>
          </chat-box>
        </yxtf-scrollbar>
        <chat-input ref="chatInputRef" :loading="loading" @send="onSubmit"></chat-input>
      </div>
    </div>
  </div>
</template>

<script>
import { AIBOXAPPID, ICON_PATH } from './config';
import chatBox from './components/chat-box.vue';
import chatInput from './components/chat-input.vue';
import feekbackBox from './components/feedback-box.vue';
import { getStaticBaseUrl, getAppInfo, getRecordHistory, createSession, feedbackItem, getExampleQuestion } from './service';
import { throttle } from 'throttle-debounce';

const getApiUrl = () => {
  return window.feConfig.common.support;
};
export default {
  name: 'YxtbizAibox',
  components: {
    chatBox,
    chatInput,
    feekbackBox
  },
  data() {
    return {
      iconUrl: `${getStaticBaseUrl()}ufd/55a3e0/assistent/pc/svg`,
      ICON_PATH,
      isFullscreen: false,
      isExpand: true,
      appData: {},
      examplePage: 0,
      exampleLoading: false,
      exampleList: [],
      qaList: [{
        role: 'assistant',
        type: 'tips'
      }],
      dataLoading: true,
      loading: false,
      sessionId: '',
      observer: null,
      activeFeedbackIndex: -1,
      feedbackLoading: false
    };
  },
  computed: {
    iconSize() {
      return this.isFullscreen ? '24px' : '20px';
    },
    gptImg() {
      return this.appData.icon;
    },
    userImg() {
      return localStorage.getItem('imgUrl') || 'https://aibox.bj.bcebos.com//yxt/appIcon/appIcon/011n/美美.jpg';
    }
  },
  mounted() {
    this.getAppData();
    this.getExample();
    try {
      const targetElement = this.$refs.aiboxRef;
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            this.goToBottom();
          }
        });
      });
      this.observer.observe(targetElement, {attributes: true});
    } catch (error) {
      console.log('🔥 不支持observer');
    }
  },
  beforeDestroy() {
    this.observer && this.observer.disconnect();
  },
  methods: {
    toggleFullscreen() {
      this.isFullscreen = !this.isFullscreen;
      this.goToBottom();
    },
    onClose() {
      this.$emit('close');
    },
    getAppData() {
      this.dataLoading = true;
      Promise.allSettled([getAppInfo(), getRecordHistory(localStorage.getItem('userId'))]).then(([appDataRes, recordHistoryRes]) => {
        const appData = appDataRes.value;
        if (appDataRes.status === 'fulfilled' && appData.code === 0) this.appData = appData.data;
        const recordHistory = recordHistoryRes.value;
        if (recordHistoryRes.status === 'fulfilled' && recordHistory.length && recordHistory.length > 0) {
          this.qaList.unshift(...recordHistory.map(item => {
            item.receiveState = 4;
            item.appraisement = 0;
            item.type = 'logs';
            item.content = item.content || '';
            return item;
          }));
        }
        this.goToBottom();
      }).finally(() => {
        this.dataLoading = false;
      });
    },
    onStaffservice() {
      this.$emit('staffService', this.sessionId);
    },
    onFeedbackItem(item, status) {
      const { data, index } = item;
      if (data.appraisement) return;
      if (status === 2) item.data.showStaffservice = true;
      this.qaList[index].appraisement = status;
      feedbackItem({id: data.recordId, isCorrect: status}).then(res => {
        if (res !== 'SUCCESS') this.qaList[index].appraisement = 0;
      });
      if (status === 2) this.activeFeedbackIndex = index;
    },
    clearQaList() {
      this.qaList = [];
    },
    buildChatItem(role, content) {
      return {
        role,
        content,
        type: 'chat',
        receiveState: 1,
        appraisement: 0,
        showStaffservice: false
      };
    },
    generateSession(name) {
      return createSession(name).then((res) => {
        if (res.code === 0) return res.data;
      });
    },
    getTextStream(url, params, {callback}) {
      const WARNING_CODE = ['AI_506'];
      const controller = new AbortController();
      let data = '';
      const info = {};
      const stopResponse = (appendText) => {
        if (appendText) data += `\n${appendText}`;
        callback(data, false, info);
      };

      const parseText = (rawData) => {
        const resData = JSON.parse(rawData.replace(/^data:/, ''));
        if (resData.recordId) info.recordId = resData.recordId;
        // 临时处理异常
        if (resData.code && !resData.data) {
          const errorMsg = `${resData.code} - ${resData.msg}`;
          stopResponse(errorMsg);
          console.log('🔥 异常信息 - ', resData);
          return;
        }
        if (resData.error_code) {
          const errorMsg = `${resData.error_code} - ${resData.error_msg}`;
          stopResponse(errorMsg);
          console.log('🔥 异常信息 - ', resData);
          return;
        }

        if (resData.choices && resData.choices[0]) {
          const choicesData = resData.choices[0];
          const errorCode = choicesData.error_code;
          const isWarning = WARNING_CODE.includes(errorCode);
          if (errorCode) {
            const em = choicesData.error_message || '模型服务异常，请稍后再试!';
            const errorMsg = isWarning ? em : `${errorCode} - ${em}`;
            stopResponse(errorMsg);
          }
          if (choicesData.delta && choicesData.delta.content) {
            data += choicesData.delta.content;
          }
          if (choicesData.finish_reason === 'stop') {
            stopResponse();
            return;
          }
          callback(data, true, info);
        }
      };

      const parseTextSafe = (rawData) => {
        try {
          parseText(rawData);
        } catch (error) {
          // const msg = '数据解析异常！';
          // stopResponse(msg);
          stopResponse();
          console.log('🔥 数据解析异常 - ', rawData);
        }
      };
      fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Token': localStorage.getItem('token')
        },
        signal: controller.signal,
        body: JSON.stringify(params)
      })
        .then(async(resp) => {
          this.qaList[this.qaList.length - 1].receiveState = 3;
          if (!resp.ok) {
            const msg = resp.status + resp.statusText;
            stopResponse(msg);
            return;
          }
          const reader = resp.body.getReader();
          const decoder = new TextDecoder();
          let prevData = '';
          for (;;) {
            const { done, value } = await reader.read();
            if (done) {
              if (prevData) parseTextSafe(prevData);
              stopResponse();
              break;
            }
            let rawData = decoder.decode(value, { stream: true });
            const rawDataArr = (prevData + rawData).split('\n\n');
            if (rawDataArr.length === 1) {
              const rawDataItem = rawDataArr[0];
              try {
                parseText(rawDataItem);
                prevData = '';
              } catch (error) {
                prevData = rawDataItem;
                continue;
              }
            } else if (rawDataArr.length > 1) {
              const lastData = rawDataArr[rawDataArr.length - 1].replace(/^data:/, '');
              try {
                JSON.parse(lastData);
                prevData = '';
              } catch (error) {
                prevData = rawDataArr.pop();
              }
              rawDataArr.forEach((rawDataItem) => {
                parseTextSafe(rawDataItem);
              });
            }
          }
        })
        .catch((e) => {
          console.log('🔥 e', e);
          stopResponse(e.message || '未知异常！');
        });
    },
    invalidCheck(str) {
      return /抱歉/.test(str);
    },
    staffserviceCheck(str) {
      return /人工|投诉/.test(str);
    },
    async onSubmit(question) {
      this.asked = true;
      this.loading = true;
      if (!this.sessionId) {
        this.sessionId = await this.generateSession(question).catch(() => {
          this.loading = false;
          const msg = '创建会话失败！';
          this.$fmessage.error(msg);
          throw new Error(msg);
        });
      }
      this.qaList.push(this.buildChatItem('user', question));
      this.$refs.chatInputRef.clearQuestion();

      if (this.staffserviceCheck(question) && this.qaList.length !== 0) {
        this.loading = false;
        const chatItem = this.buildChatItem('assistant', '');
        chatItem.type = 'staffservice';
        this.qaList.push(chatItem);
        this.viewBottom(this);
        return;
      }

      const msgList = this.qaList.filter(item => !['logs', 'tips', 'staffservice'].includes(item.type)).map(item => {
        return {role: item.role, content: item.content, appraisement: item.appraisement};
      });
      this.getTextStream(
        getApiUrl() + 'aibox/stream/qa/ask',
        {
          accountNo: localStorage.getItem('username'),
          appId: AIBOXAPPID,
          messages: msgList.slice(-21, msgList.length),
          topicId: this.sessionId,
          orgId: 'yxt',
          platform: 'help-center'
        },
        {
          callback: (data, loading, {recordId}) => {
            const current = this.qaList[this.qaList.length - 1];
            current.content = data;
            current.recordId = recordId;
            this.loading = loading;
            this.viewBottom(this);
            if (!this.loading) {
              current.receiveState = 4;
              if (this.invalidCheck(current.content)) current.showStaffservice = true;
            }
          }
        }
      );
      this.qaList.push(this.buildChatItem('assistant', ''));
      this.viewBottom(this);
      setTimeout(() => {this.qaList[this.qaList.length - 1].receiveState = 2;this.viewBottom(this);}, 1000);
    },
    goToBottom() {
      this.$nextTick(() => {
        this.$refs.chatBoxRef && this.$refs.chatBoxRef.$el.scrollIntoView({ block: 'end' });
      });
    },
    // 存在多个数据同时返回的情况，时间临时写小点
    viewBottom: throttle(30, false, (t) => {
      if (t.$refs.chatBoxRef) t.$nextTick(() => {t.$refs.chatBoxRef.$el.scrollIntoView({ behavior: 'smooth', block: 'end' });});
    }, false),
    onSelectQuestion(q) {
      this.$refs.chatInputRef.setQuestion(q);
    },
    getExample() {
      this.exampleLoading = true;
      this.examplePage += 1;
      if (this.examplePage > 1000) this.examplePage = 1;
      getExampleQuestion(this.examplePage).then(res => {
        this.exampleList = res;
      }).finally(() => {
        this.exampleLoading = false;
      });
    },
    onSubmitFeedback(item, tags, content) {
      this.feedbackLoading = true;
      const {recordId: id} = item;
      const reason = tags.join(',') + ',' + content;
      feedbackItem({id, reason}).then(res => {
        if (res === 'SUCCESS') {
          this.$message.success('反馈成功！');
          this.activeFeedbackIndex = -1;
        } else {
          this.$message.error('反馈失败！');
        }
      }).finally(() => {
        this.feedbackLoading = false;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>